import {Regulation} from 'types';
import {TFunction} from 'react-i18next';
import {
	renderHeaderXL,
	createZIPXL,
	renderArrayXL,
	renderRowItemAsLinkXL,
} from './ExcelExportCommon';
import Excel from 'exceljs';

interface IRegulationsPage {
	(entityListItems: any[], columnNames: string[], t: TFunction): Promise<void>;
}

export const handleClickRegulations: IRegulationsPage = async (
	entityListItems,
	columnNames,
	t,
) => {
	const filtRegulation = entityListItems as Regulation[];

	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet(
		'TRACE_' +
			t('Regulations', {
				ns: 'features/regulations',
				keyPrefix: 'RegulationsList',
			}),
	);
	const columns = [
		{name: ' ', filterButton: false},
		...columnNames.slice(1).map(x => {
			return {name: x, filterButton: true};
		}),
	];
	const arrColWidth: number[] = [10, 40, 80, ...new Array(4).fill(25)];
	const strPageName = '';

	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.alignment = {wrapText: true, vertical: 'top'};
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};

	sheet.addTable({
		name: 'Regulations',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns,
		rows: [],
	});

	const table = sheet.getTable('Regulations');

	intRowCount++;
	for (let ii = 0; ii < filtRegulation.length; ii++) {
		const iRegulation = filtRegulation[ii];
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		table.addRow([
			'',
			iRegulation.regulationNumber,
			iRegulation.name,
			renderArrayXL(iRegulation.markets),
			renderArrayXL(iRegulation.mainKeywords),
			renderArrayXL(iRegulation.keywords),
			renderArrayXL(iRegulation.standardPlusPcmsClusters),
		]);
		intRowCount++;

		const arrAttach = iRegulation.attachments ?? [];
		arrAttach.forEach(iAttach => {
			intRowCount = renderRowItemAsLinkXL(
				intRowCount,
				iAttach.file?.fileName ?? iAttach.attachmentId,
				iAttach.file?.uri ?? '',
				'C',
				1,
				sheet,
				table,
				t,
			);
		});
	}

	table.commit();
	const strZipName = t('Regulations', {
		ns: 'features/regulations',
		keyPrefix: 'RegulationsList',
	});
	await createZIPXL(workbook, strZipName, t);
};
